import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AccessControlPolicy } from 'src/app/models/usermanagement/accessControl';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class AccesscontrolPolicyService {
  //o3CoreApiUrl: string = environment.O3CoreApiUrl;
  o3CoreApiUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getPolicyByGroup(id: number): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<AccessControlPolicy[]>(this.o3CoreApiUrl + 'AccessControlPolicy/getPolicyByGroup/' + id, { headers: header });
  }

  craetePolicy(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'AccessControlPolicy/createPolicy', data, { headers: header });
  }

  updatePolicy(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'AccessControlPolicy/updatePolicy', data, { headers: header });
  }

  deletePolicy(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'AccessControlPolicy/deletePolicy', data, { headers: header });
  }
}
